import { inject } from '@angular/core';
import { environments as env } from '../../../environments/environments';
import { HttpClient } from '@angular/common/http';

export class Api {
  protected http: HttpClient = inject(HttpClient);

  protected url = env.appUrls.backend;
}
